import { router } from "@inertiajs/react";

// A trick to handle Inertia 'httpException' events in a better way
// Normally InertiaJS will try to load the httpException response into a modal
// but that does not work well when navigating between Inertia and non-Inertia views
// So instead we will replace the current document content and update the URL
// The reason we do this instead of just setting window.location.href is to not
// lose flash messages that will be lost on a full page reload
router.on("httpException", (event) => {
  // Prevent InertiaJS from showing the modal with the new content
  event.preventDefault();

  const response = event.detail.response;

  // If the response events target is the document, we can get the URL from it,
  // otherwise we will fallback to the current window location
  let responseUrl: string;
  if (event.target instanceof HTMLDocument) {
    responseUrl = event.target.URL;
  } else {
    responseUrl = window.location.href;
  }

  const responseHtml = typeof response.data === "string" ? response.data : "";

  // Here we do a little trick to ensure that when user navigates back,
  // we do a full page reload to load the view correctly
  // Replace current state to indicate that a reload is needed if user navigates back
  // In the popstate event listener below in this file, we will check for this state
  // and do a full page reload if needed
  history.replaceState({ reload: true }, "", window.location.href);

  // Push new state to history to update the URL without reloading the page if the URL has changed.
  // This is important to keep the URL in sync with the content.
  if (responseUrl !== window.location.href) {
    history.pushState({}, "", responseUrl);
  }

  // Now we want to replace the current document content with the new response content
  // We will look for the #application element in the new response and replace the current
  // #application content with it. This way we keep all markup outside #application intact.
  const applicationWrapper = document.getElementById("application");
  const tempElement = document.createElement("div");
  tempElement.innerHTML = responseHtml;

  const newWrapper = tempElement.querySelector("#application");

  // If we can't find the wrapper element in the new response, we will fallback to a full page reload
  if (!applicationWrapper || !newWrapper) {
    window.location.href = responseUrl;
    return;
  }

  applicationWrapper.innerHTML = newWrapper.innerHTML;

  applicationWrapper.dispatchEvent(
    new Event("DOMContentLoaded", { bubbles: true, cancelable: true })
  );
  applicationWrapper.dispatchEvent(
    new Event("inertia-hack:invalid-route", { bubbles: true, cancelable: true })
  );
});

window.addEventListener("popstate", function (event) {
  // Check if the state indicates that a reload is needed
  // If so, do a full page reload
  if (event.state && event.state.reload === true) {
    window.location.reload();
  }
});
